import { defineComponent as _defineComponent } from 'vue'
import AppHeader from "@/components/AppHeader.vue";
import { useUserStore } from "@/stores/user";
import type { IUserMenuOption } from "@/types/entities/IUserMenuOption";
import routesName from "@/utils/constants/routesName";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileLayout',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();

const onLogout = (): void => {
  userStore.clear();
};
const menuOptions: IUserMenuOption[] = [
  {
    iconName: "tabler-icon-layout-dashboard",
    label: "Dashboard",
    routeName: routesName.dashboard,
  },
  {
    iconName: "tabler-icon-school",
    label: "My Courses",
    routeName: routesName.myCourses,
  },
  {
    iconName: "tabler-icon-certificate",
    label: "My Certificates",
    routeName: routesName.myCertificates,
  },
  {
    iconName: "tabler-icon-transcript",
    label: "My Transcript",
    routeName: routesName.myTranscript,
  },
  {
    iconName: "tabler-icon-user-circle",
    label: "My Profile",
    routeName: routesName.myProfile,
  },
  {
    iconName: "tabler-icon-settings",
    label: "My Settings",
    routeName: routesName.mySettings,
  },
];

const __returned__ = { userStore, onLogout, menuOptions, AppHeader, get useUserStore() { return useUserStore }, get routesName() { return routesName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})